document.addEventListener("DOMContentLoaded", function (event) {
  const Settings = {
    url: window.location.hostname,
  };

  const Site = {
    init: function () {
      Site.bindEvents();
    },

    bindEvents: function () {},
  };

  var galleryElems = document.querySelectorAll(".js-carousel");

  for (var i = 0, len = galleryElems.length; i < len; i++) {
    var galleryElem = galleryElems[i];
    new Flickity(galleryElem, {
      // options...
      cellAlign: "left",
      contain: true,
      prevNextButtons: true,
      pageDots: true,
      wrapAround: true,
      autoPlay: false,
      imagesLoaded: true,
      percentPosition: false,
      adaptiveHeight: true,
      draggable: true,
      freeScroll: false,
      // friction: 0.2,
      // selectedAttraction: 0.025,

      groupCells: false,
      accessibility: false, // stop scroll to top on click
    });
  }

  var bannerCarouselElems = document.querySelectorAll(".js-carousel-banners");

  for (var i = 0, len = bannerCarouselElems.length; i < len; i++) {
    var bannerCarouselElem = bannerCarouselElems[i];
    let bannerCarouselInstance = new Flickity(bannerCarouselElem, {
      // options...
      cellAlign: "left",
      contain: true,
      prevNextButtons: false,
      pageDots: true,
      wrapAround: true,
      // autoPlay: 3000,
      imagesLoaded: true,
      percentPosition: false,
      adaptiveHeight: true,
      draggable: false,
      freeScroll: false,
      // friction: 0.2,
      // selectedAttraction: 0.025,
      groupCells: false,
      accessibility: false, // stop scroll to top on click
      // pauseAutoPlayOnHover: false
    });

    // get the current slide element
    // console.log('bannerCarouselInstance', bannerCarouselInstance);

    // listen for the carousel to change slides
    bannerCarouselInstance.on("change", function (index) {
      // console.log('bannerCarouselInstance change', index);

      // get the current slide element
      var currentSlideElem = bannerCarouselInstance.selectedElement;
      // console.log('currentSlideElem', currentSlideElem);

      // get the data attr 'data-colour-class' from the current slide element
      var currentSlideColourClass =
        currentSlideElem.getAttribute("data-colour-class");
      // console.log('currentSlideColourClass', currentSlideColourClass);

      // remove classes beginning with 'color-' from the current bannerCarouselElem
      var classes = bannerCarouselElem.classList;
      for (var i = 0, len = classes.length; i < len; i++) {
        var className = classes[i];
        if (className.indexOf("color-") === 0) {
          bannerCarouselElem.classList.remove(className);
        }
      }

      // add the currentSlideColourClass to the bannerCarouselElem
      bannerCarouselElem.classList.add(currentSlideColourClass);

      // add class 'hide page-dots' to the bannerCarouselElem for 444ms
      bannerCarouselElem.classList.add("hide-page-dots");
      setTimeout(function () {
        bannerCarouselElem.classList.remove("hide-page-dots");
      }, 444);
    });

    // force the carousel to change every 3 seconds
    let autoPlayInterval = setInterval(function () {
      bannerCarouselInstance.next();
    }, 8000);

    // when click on page dots, reset the autoPlayInterval
    var pageDots = bannerCarouselElem.querySelector(".flickity-page-dots");
    pageDots.addEventListener("click", function (event) {
      clearInterval(autoPlayInterval);
      autoPlayInterval = setInterval(function () {
        bannerCarouselInstance.next();
      }, 8000);
    });
  }

  var productImageCarouselElems = document.querySelectorAll(
    ".js-product-images-carousel"
  );
  let productCurrentValueSpan = document.querySelector(
    ".js-current-variant-value"
  );

  if (productImageCarouselElems.length > 0) {
    var productImageCarouselElem = productImageCarouselElems[i];

    let productCarouselInstance = new Flickity(productImageCarouselElem, {
      // options...
      cellAlign: "left",
      contain: true,
      prevNextButtons: true,
      pageDots: true,
      wrapAround: true,
      autoPlay: false,
      imagesLoaded: true,
      percentPosition: false,
      adaptiveHeight: true,
      draggable: true,
      freeScroll: false,
      // friction: 0.2,
      // selectedAttraction: 0.025,
      groupCells: false,
      accessibility: false, // stop scroll to top on click
    });

    // console.log('productImageCarouselElems.length > 0');
    // get the variant param from the url
    var urlParams = new URLSearchParams(window.location.search);
    var variant = urlParams.get("variant");

    // console.log('variant', variant);

    // if there is a variant param, find the index of the variant in the carousel
    if (variant) {
      var productImageCarousel = productImageCarouselElems[0];
      var cells = productImageCarousel.querySelectorAll(".carousel-cell");
      var variantIndex = 0;
      for (var i = 0, len = cells.length; i < len; i++) {
        var cell = cells[i];
        var cellVariant = cell.getAttribute("data-variant-id");
        if (cellVariant == variant) {
          variantIndex = i;
          // console.log('variantIndex', variantIndex);
          break;
        }
      }

      // if the variant was found, set the carousel to that index
      if (variantIndex) {
        productCarouselInstance.select(variantIndex);
      }
    }

    // on clicking of a 'label' element, find the index of the variant in the carousel
    var productVariantLabels = document.querySelectorAll(
      ".js-core-product-variant"
    );

    productVariantLabels.forEach(function (productVariantLabel) {
      productVariantLabel.addEventListener("click", function (event) {
        setTimeout(function () {
          var urlParams = new URLSearchParams(window.location.search);
          var variant = urlParams.get("variant");

          let variantValue = productVariantLabel.getAttribute("data-value");
          // console.log(this, 'variantValue', variantValue);
          productCurrentValueSpan.innerHTML = variantValue;

          // console.log('variant', variant);

          // if there is a variant param, find the index of the variant in the carousel
          if (variant) {
            var productImageCarousel = productImageCarouselElems[0];
            var cells = productImageCarousel.querySelectorAll(".carousel-cell");
            var variantIndex = -1;
            for (var i = 0, len = cells.length; i < len; i++) {
              var cell = cells[i];
              var cellVariant = cell.getAttribute("data-variant-id");
              if (cellVariant == variant) {
                variantIndex = i;
                // productCarouselInstance.select(variantIndex);
                // select without animation
                productCarouselInstance.selectCell(variantIndex, false, true);

                // console.log('variantIndex', variantIndex);
                break;
              }
            }

            // if the variant was found, set the carousel to that index
            // if(variantIndex) {
            //   productCarouselInstance.select(variantIndex);
            // }
          }
        }, 111);
      });
    });
  }
  function onKeyPress(keyCode, functionName) {
    // Map a keypress to a function easily

    document.keyup(function (e) {
      if (e.keyCode == keyCode) {
        functionName.call();
      }
    });
  }

  function random(min, max) {
    // Returns a random number given a min and max

    return Math.floor(Math.random() * (max - min + 1) + min);
  }

  function checkLinks() {
    // Automatically set a target for links based on their href

    var links = document.getElementsByTagName("a");
    for (var i = 0; i < links.length; i++) {
      href = links[i].getAttribute("href");

      if (links[i].getAttribute("target") == "_blank") {
        // do nothing
      } else if (href == null) {
        // do nothing
      } else if (href.startsWith("/")) {
        links[i].setAttribute("target", "_self");
      } else if (href.includes(Settings.url)) {
        links[i].setAttribute("target", "_self");
      } else if (href.startsWith("http://")) {
        links[i].setAttribute("target", "_blank");
      } else if (href.startsWith("https://")) {
        links[i].setAttribute("target", "_blank");
      } else if (href.startsWith("mailto")) {
        links[i].setAttribute("target", "_blank");
      } else if (href.startsWith("#")) {
        links[i].setAttribute("target", "_self");
      }
    }
  }

  checkLinks();
  const Menu = {
    body: document.querySelector("body"),
    el: document.querySelector(".js-menu"),
    isOpen: false,
    trigger: document.querySelector(".js-menu-trigger"),
    menuLabelDesktop: document.querySelector(".js-menu-label-desktop"),

    init() {
      Menu.bindEvents();
    },

    bindEvents() {
      Menu.trigger.addEventListener("click", Menu.toggle);
      window.addEventListener("keyup", function (e) {
        if (e.keyCode == 27) {
          Menu.close();
        }
      });
    },

    toggle() {
      if (Menu.isOpen) {
        Menu.close();
      } else {
        Menu.open();
      }
    },

    close() {
      Menu.isOpen = false;
      Menu.el.classList.remove("is-active");
      Menu.menuLabelDesktop.innerHTML = "Menu";
      Menu.menuLabelDesktop.setAttribute("data-menu-open", "false");
      Menu.body.setAttribute("data-menu-open", false);
    },

    open() {
      Menu.isOpen = true;
      Menu.el.classList.add("is-active");
      Menu.menuLabelDesktop.innerHTML = "Close";
      Menu.menuLabelDesktop.setAttribute("data-menu-open", "true");
      Menu.body.setAttribute("data-menu-open", true);
    },
  };

  Menu.init();
  // '.js-wholesale-line'

  // Class for wholesale line

  class WholesaleLine {
    constructor(el) {
      this.el = el;
      this.sku = this.el.getAttribute("data-sku");
      this.price = this.el.getAttribute("data-wholesale-price");
      this.quantityInputEl = this.el.querySelector(".js-quantity-input");
      this.lineTotal = 0;
      this.quantity = 0;

      this.quantityIncreaseEl = this.el.querySelector(".js-quantity-up");
      this.quantityDecreaseEl = this.el.querySelector(".js-quantity-down");

      this.quantityInputEl.addEventListener(
        "change",
        this.updateInput.bind(this)
      );
      this.quantityIncreaseEl.addEventListener(
        "click",
        this.increaseQuantity.bind(this)
      );
      this.quantityDecreaseEl.addEventListener(
        "click",
        this.decreaseQuantity.bind(this)
      );

      // log the wholesale line
      // console.log(this);
    }

    updateInput() {
      let self = this;
      let updatedQuantity = self.quantityInputEl.value;
      self.quantity = parseInt(updatedQuantity);

      self.updateLine();
    }

    increaseQuantity() {
      let self = this;
      if (self.quantity < 999) {
        self.quantity++;
        self.quantityInputEl.value = self.quantity;
        self.updateLine();
      }
    }

    decreaseQuantity() {
      let self = this;
      if (self.quantityInputEl.value > 0) {
        self.quantity--;
        self.quantityInputEl.value = self.quantity;
        self.updateLine();
      }
    }

    updateLine() {
      let self = this;

      if (self.quantity <= 0) {
        self.quantity = 0;
      }

      if (self.quantity >= 999) {
        self.quantity = 999;
      }

      // if self.quantity is NaN, set it to 0
      if (isNaN(self.quantity)) {
        self.quantity = 0;
      }

      self.quantityInputEl.value = self.quantity;

      self.lineTotal = self.quantity * self.price;

      self.el.setAttribute("data-line-quantity", self.quantity);
      self.el.setAttribute("data-line-total", self.lineTotal);
      // console.log('update line', self.sku, self.quantity);

      Wholesale.calculateSubtotal();
      Wholesale.calculateGST();
    }
  }

  const Wholesale = {
    lines: document.querySelectorAll(".js-wholesale-line"),
    totalFloatingNum: 0,
    gstFloatingNum: 0,
    totalMoneyFormated: "$0.00",
    gstMoneyFormated: "$0.00",
    totalEl: document.querySelector(".js-wholesale-total"),
    gstEl: document.querySelector(".js-wholesale-gst"),
    totalInputEl: document.querySelector("#js-wholesale-total-input"),
    gstInputEl: document.querySelector("#js-wholesale-gst-input"),

    init: function () {
      Wholesale.initLines();
      Wholesale.calculateSubtotal();
      Wholesale.calculateGST();
    },

    initLines: function () {
      Wholesale.lines.forEach(function (el) {
        new WholesaleLine(el);
      });
    },

    calculateSubtotal: function () {
      Wholesale.totalFloatingNum = 0;
      Wholesale.lines.forEach(function (el) {
        Wholesale.totalFloatingNum += parseInt(
          el.getAttribute("data-line-total")
        );
      });

      // format Whole.totalMoneyFormated with commas so 123456.78 becomes "$123,456.78"
      Wholesale.totalMoneyFormated =
        "$" +
        Wholesale.totalFloatingNum
          .toFixed(2)
          .replace(/(\d)(?=(\d{3})+\.)/g, "$1,");
      Wholesale.totalEl.innerHTML = Wholesale.totalMoneyFormated;
      Wholesale.totalInputEl.value = Wholesale.totalMoneyFormated;
    },

    calculateGST: function () {
      Wholesale.gstFloatingNum = Wholesale.totalFloatingNum * 0.15;
      // Wholesale.gstMoneyFormated = '$' + Wholesale.gstFloatingNum.toFixed(2);
      // format Whole.gstMoneyFormated with commas so 123456.78 becomes "$123,456.78"
      Wholesale.gstMoneyFormated =
        "$" +
        Wholesale.gstFloatingNum
          .toFixed(2)
          .replace(/(\d)(?=(\d{3})+\.)/g, "$1,");
      // Wholesale.gstEl.innerHTML = Wholesale.gstMoneyFormated;
      // Wholesale.gstInputEl.value = Wholesale.gstMoneyFormated;
    },
  };

  if (document.querySelector(".js-wholesale-line")) {
    Wholesale.init();
  }

  const Newsletter = {
    htmlEl: document.querySelector("html"),
    el: document.querySelector(".js-newsletter-popup"),
    close: document.querySelector(".js-newsletter-close"),
    sheen: document.querySelector(".js-newsletter-sheen"),

    init() {
      Newsletter.bindEvents();
      Newsletter.sheen.addEventListener("click", Newsletter.closePopup);
      Newsletter.close.addEventListener("click", Newsletter.closePopup);
    },

    bindEvents() {
      setTimeout(function () {
        Newsletter.openPopup();
      }, 3000);
    },

    openPopup() {
      Newsletter.el.classList.remove("is-hidden");
      Newsletter.htmlEl.classList.add("lock-scroll");
    },

    closePopup() {
      Newsletter.el.classList.add("is-hidden");
      Newsletter.htmlEl.classList.remove("lock-scroll");
    },

    lockScroll() {
      Newsletter.htmlEl.classList.add("lock-scroll");
    },
  };

  if (Newsletter.el) {
    Newsletter.init();
  }

  let allProductCardsWithColours = document.querySelectorAll(
    ".js-product-card[data-colour]"
  );
  let coloursArray = [];

  allProductCardsWithColours.forEach(function (productCard) {
    let colour = productCard.dataset.colour;
    coloursArray.push(colour);
  });

  let uniqueColoursArray = [...new Set(coloursArray)];

  // put in alphabetical order
  uniqueColoursArray.sort();

  let colourFilters = document.querySelector(".js-colour-filters");

  uniqueColoursArray.forEach(function (colour) {
    let colourFilter = document.createElement("button");
    colourFilter.classList.add("filter-option");
    colourFilter.classList.add("js-filter-option");
    colourFilter.dataset.filterBy = "colour";
    colourFilter.dataset.filterValue = colour;
    colourFilter.innerHTML = colour;
    colourFilters?.appendChild(colourFilter);
  });

  const Filters = {
    showingFilters: false,
    showingSearch: false,

    container: document.querySelector(".js-section-product-filters-container"),

    filtersToggle: document.querySelector(".js-filters-toggle"),
    searchToggle: document.querySelector(".js-search-toggle"),

    allProductsContainer: document.querySelector(".js-all-products-container"),

    filterableCards: document.querySelectorAll(".js-product-card"),
    filterSelects: document.querySelectorAll(".js-filter-select"),

    allFilterOptions: document.querySelectorAll(".js-filter-options"),
    currentFilterBy: null,

    filterOptionEls: document.querySelectorAll(".js-filter-option"),
    currentFilterOption: null,

    searchInput: document.querySelector(".js-search-input"),
    searchArea: document.querySelector(".js-search-area"),

    productCollections: document.querySelectorAll(".js-product-collection"),

    validCardsCount: null,

    resetFiltersTriggers: document.querySelectorAll(".js-reset-filters"),

    init: function () {
      Filters.bindEvents();
      // console.log('Filters', Filters);
      Filters.countValidCards();
    },

    bindEvents: function () {
      Filters.filterSelects.forEach(function (filterSelect) {
        filterSelect.addEventListener("click", Filters.updateSelectedFilter);
      });

      Filters.filterOptionEls.forEach(function (filterOptionEl) {
        filterOptionEl.addEventListener("click", Filters.updateFilterOption);
      });

      Filters.resetFiltersTriggers.forEach(function (resetFiltersTrigger) {
        resetFiltersTrigger.addEventListener("click", Filters.clearFilters);
      });

      Filters.searchToggle.addEventListener("click", Filters.toggleSearch);
      Filters.searchInput.addEventListener("keyup", Filters.searchProducts);
      Filters.filtersToggle?.addEventListener("click", Filters.toggleFilters);
    },

    toggleSearch: function () {
      // if search is showing, hide it
      if (Filters.showingSearch) {
        Filters.searchInput.value = "";
        Filters.searchArea.classList.remove("is-visible");
        Filters.showingSearch = false;
      } else {
        Filters.searchArea.classList.add("is-visible");
        Filters.searchInput.focus();
        Filters.showingSearch = true;

        if (Filters.showingFilters) {
          Filters.toggleFilters();
        }
      }

      Filters.container.setAttribute("data-show-search", Filters.showingSearch);
      Filters.allProductsContainer.setAttribute(
        "data-show-search",
        Filters.showingSearch
      );
    },

    toggleFilters: function () {
      // if filters are showing, hide them
      if (Filters.showingFilters) {
        Filters.showingFilters = false;
      } else {
        Filters.showingFilters = true;

        if (Filters.showingSearch) {
          Filters.toggleSearch();
        }
      }

      Filters.container.setAttribute(
        "data-show-filters",
        Filters.showingFilters
      );
    },

    searchProducts: function () {
      let searchQuery = Filters.searchInput.value.toLowerCase();
      // console.log('searchProducts', searchQuery);

      Filters.filterableCards.forEach(function (filterableCard) {
        let cardSearchableText =
          filterableCard.dataset.searchable.toLowerCase();
        if (cardSearchableText.includes(searchQuery)) {
          filterableCard.classList.remove("is-hidden");
          filterableCard.classList.add("is-visible");
        } else {
          filterableCard.classList.add("is-hidden");
          filterableCard.classList.remove("is-visible");
        }
      });

      Filters.countValidCards();
    },

    updateSelectedFilter: function (event) {
      // clear filters
      Filters.clearFilters();

      let triggerEl = event.currentTarget;
      Filters.currentFilterBy = triggerEl.getAttribute("data-filter-select");

      // remove is-active class from all filter selects
      Filters.filterSelects.forEach(function (filterSelect) {
        filterSelect.classList.remove("is-selected");
      });

      // add is-selected class to current filter select
      triggerEl.classList.add("is-selected");

      // select all filter options and remove is-current-filter class
      let allFilterOptions = document.querySelectorAll(".js-filter-options");
      allFilterOptions.forEach(function (filterOption) {
        filterOption.classList.remove("is-current-filter");
      });

      let selectFilterOptionsQuery =
        '.js-filter-options[data-filter="' + Filters.currentFilterBy + '"]';
      let selectFilterOptions = document.querySelector(
        selectFilterOptionsQuery
      );
      // console.log(triggerEl, Filters.currentFilterBy, selectFilterOptionsQuery, selectFilterOptions);
      selectFilterOptions.classList.add("is-current-filter");
    },

    updateFilterOption: function (event) {
      let triggerEl = event.currentTarget;
      Filters.currentFilterBy = triggerEl.getAttribute("data-filter-by");
      Filters.currentFilterOption = triggerEl.getAttribute("data-filter-value");

      // check if filter option is already active
      if (triggerEl.classList.contains("is-active")) {
        // if so, remove is-active class and return
        triggerEl.classList.remove("is-active");
        Filters.currentFilterOption = null;
      } else {
        // remove is-active class from all filter options
        Filters.filterOptionEls.forEach(function (filterOptionEl) {
          filterOptionEl.classList.remove("is-active");
        });

        // add is-active class to current filter option
        triggerEl.classList.add("is-active");
      }

      // filter cards
      Filters.filterCards();
    },

    filterCards: function () {
      // console.log('filterCards', Filters.currentFilterBy, Filters.currentFilterOption);

      if (Filters.currentFilterOption == null) {
        Filters.clearFilters();
      } else {
        if (Filters.currentFilterBy == "colour") {
          Filters.filterByColour();
        }

        if (Filters.currentFilterBy == "size") {
          Filters.filterBySize();
        }

        if (Filters.currentFilterBy == "price") {
          Filters.filterByPrice();
        }

        if (Filters.currentFilterBy == "category") {
          Filters.filterByCategory();
        }
      }

      Filters.countValidCards();
    },

    filterByColour: function () {
      Filters.filterableCards.forEach(function (filterableCard) {
        let cardColour = filterableCard.dataset.colour;
        if (cardColour == Filters.currentFilterOption) {
          filterableCard.classList.remove("is-hidden");
          filterableCard.classList.add("is-visible");
        } else {
          filterableCard.classList.add("is-hidden");
          filterableCard.classList.remove("is-visible");
        }
      });
    },

    filterBySize: function () {
      Filters.filterableCards.forEach(function (filterableCard) {
        let cardSize = filterableCard.dataset.size.toLowerCase();
        if (cardSize == Filters.currentFilterOption) {
          filterableCard.classList.remove("is-hidden");
          filterableCard.classList.add("is-visible");
        } else {
          filterableCard.classList.add("is-hidden");
          filterableCard.classList.remove("is-visible");
        }
      });
    },

    filterByPrice: function () {
      let minPrice = null;
      let maxPrice = null;

      if (Filters.currentFilterOption == "0-100") {
        minPrice = 0;
        maxPrice = 100;
      }

      if (Filters.currentFilterOption == "101-500") {
        minPrice = 101;
        maxPrice = 500;
      }

      if (Filters.currentFilterOption == "501-1500") {
        minPrice = 501;
        maxPrice = 1000;
      }

      if (Filters.currentFilterOption == "1501+") {
        minPrice = 1501;
        maxPrice = 9999999;
      }

      // console.log('filterByPrice', minPrice, maxPrice);

      Filters.filterableCards.forEach(function (filterableCard) {
        let cardPrice = parseFloat(filterableCard.dataset.price); // convert to float
        if (cardPrice >= minPrice && cardPrice <= maxPrice) {
          filterableCard.classList.remove("is-hidden");
          filterableCard.classList.add("is-visible");
        } else {
          filterableCard.classList.add("is-hidden");
          filterableCard.classList.remove("is-visible");
        }
      });
    },

    filterByCategory: function () {
      if (Filters.currentFilterOption == "gifts") {
        // check [data-is-gift="true"]
        Filters.filterableCards.forEach(function (filterableCard) {
          let isGift = filterableCard.dataset.isGift;
          if (isGift == "true") {
            filterableCard.classList.remove("is-hidden");
            filterableCard.classList.add("is-visible");
          } else {
            filterableCard.classList.add("is-hidden");
            filterableCard.classList.remove("is-visible");
          }
        });
      }

      if (Filters.currentFilterOption == "wall-hung") {
        // check [data-is-wall-hung="true"]
        Filters.filterableCards.forEach(function (filterableCard) {
          let isWallHung = filterableCard.dataset.isWallHung;
          if (isWallHung == "true") {
            filterableCard.classList.remove("is-hidden");
            filterableCard.classList.add("is-visible");
          } else {
            filterableCard.classList.add("is-hidden");
            filterableCard.classList.remove("is-visible");
          }
        });
      }

      if (Filters.currentFilterOption == "lighting") {
        // check [data-is-lighting="true"]
        Filters.filterableCards.forEach(function (filterableCard) {
          let isLighting = filterableCard.dataset.isLighting;
          if (isLighting == "true") {
            filterableCard.classList.remove("is-hidden");
            filterableCard.classList.add("is-visible");
          } else {
            filterableCard.classList.add("is-hidden");
            filterableCard.classList.remove("is-visible");
          }
        });
      }

      if (Filters.currentFilterOption == "fine-art") {
        // check [data-is-fine-art="true"]
        Filters.filterableCards.forEach(function (filterableCard) {
          let isFineArt = filterableCard.dataset.isFineArt;
          if (isFineArt == "true") {
            filterableCard.classList.remove("is-hidden");
            filterableCard.classList.add("is-visible");
          } else {
            filterableCard.classList.add("is-hidden");
            filterableCard.classList.remove("is-visible");
          }
        });
      }
    },

    clearFilters: function () {
      Filters.currentFilterBy = null;
      Filters.currentFilterOption = null;
      Filters.searchInput.value = "";

      Filters.filterOptionEls.forEach(function (filterOptionEl) {
        filterOptionEl.classList.remove("is-active");
      });

      Filters.filterableCards.forEach(function (filterableCard) {
        filterableCard.classList.remove("is-hidden");
        filterableCard.classList.add("is-visible");
      });

      Filters.countValidCards();
    },

    countValidCards: function () {
      Filters.validCardsCount = document.querySelectorAll(
        ".js-product-card.is-visible"
      ).length;
      // console.log('Filters.validCardsCount', Filters.validCardsCount);

      Filters.allProductsContainer.setAttribute(
        "data-count",
        Filters.validCardsCount
      );
      Filters.countValidCardsInCollections();
    },

    countValidCardsInCollections: function () {
      Filters.productCollections.forEach(function (productCollection) {
        let validCardsCount = productCollection.querySelectorAll(
          ".js-product-card.is-visible"
        ).length;
        let collectionLeftoverCount = 4 - (validCardsCount % 4);
        // console.log('validCardsCount', validCardsCount);
        productCollection.setAttribute("data-count", validCardsCount);
        productCollection.setAttribute(
          "data-leftover",
          collectionLeftoverCount
        );
      });
    },
  };

  let template = document.querySelector("body").getAttribute("data-template");

  if (template == "list-collections") {
    Filters.init();
  }

  if (template == "collection") {
    Filters.init();
  }

  // if user is on the 'shop-all' page with query string 'show-search' set to 'true'
  // then open the search area
  let searchParam = new URLSearchParams(window.location.search).get(
    "show-search"
  );
  if (searchParam == "true") {
    Filters.toggleSearch();

    // scroll to 'js-section-product-filters-container' + header height
    let headerHeight = document.querySelector(".js-site-header").offsetHeight;

    let containerTop = Filters.container.offsetTop;

    window.scrollTo({
      top: containerTop - headerHeight,
      behavior: "instant",
    });
  }

  //   // lottie
  // var footerSignature = bodymovin.loadAnimation({
  //   container: document.querySelector('.js-slw-signature-lottie'),
  //   renderer: 'svg',
  //   loop: false,
  //   autoplay: false,
  //   path: document.querySelector('.js-slw-signature-lottie').getAttribute('data-path')
  // });

  const Footer = {
    el: document.querySelector(".js-footer"),
    nameAndSignatureContainer: document.querySelector(
      ".js-name-signature-container"
    ),
    state: "text",
    endOfPage: false,
    currentScrollPosition: 0,
    totalScrollHeight: null,
    currentScrollPercentage: 0,
    logoVideo: document.querySelector(".js-slw-signature-video"),

    init() {
      window.addEventListener("scroll", Footer.scrollHandler);
      window.addEventListener("resize", Footer.resizeHandler);
      Footer.totalScrollHeight =
        document.body.scrollHeight - window.innerHeight;
    },

    resizeHandler() {
      Footer.totalScrollHeight =
        document.body.scrollHeight - window.innerHeight;
    },

    scrollHandler() {
      Footer.currentScrollPosition = window.scrollY;
      Footer.currentScrollPercentage =
        Footer.currentScrollPosition / Footer.totalScrollHeight;
      // console.log('Footer.currentScrollPercentage', Footer.currentScrollPercentage);

      if (Footer.currentScrollPercentage > 0.95 && Footer.state == "text") {
        Footer.endOfPage = true;
        Footer.state = "signature";
        Footer.nameAndSignatureContainer.setAttribute(
          "data-state",
          Footer.state
        );
        Footer.animateSignature();
      }
    },

    animateSignature() {
      setTimeout(function () {
        Footer.logoVideo.play();
      }, 444);
    },
  };

  Footer.init();
  // const Product = {
  //   orderDetailsEl: document.querySelector('.js-product-details'),
  //   customEngraveCheckbox: document.querySelector('.js-custom-engrave-checkbox'),
  //   addNoteCheckbox: document.querySelector('.js-add-note-checkbox'),
  //   customEngraveInput: document.querySelector('.js-custom-engrave-input'),
  //   addNoteInput: document.querySelector('.js-add-note-input'),

  //   init() {
  //     Product.bindEvents();
  //     console.log(Product);
  //   },

  //   bindEvents() {
  //     Product.customEngraveCheckbox.addEventListener('change', Product.toggleCustomEngrave);
  //     Product.addNoteCheckbox.addEventListener('change', Product.toggleAddNote);
  //   },

  //   toggleCustomEngrave() {
  //     if (Product.customEngraveCheckbox.checked) {
  //       Product.orderDetailsEl.setAttribute('data-custom-engrave', true);
  //     }
  //     else {
  //       Product.orderDetailsEl.setAttribute('data-custom-engrave', false);
  //       Product.customEngraveInput.value = '';
  //     }
  //   },

  //   toggleAddNote() {
  //     if (Product.addNoteCheckbox.checked) {
  //       Product.orderDetailsEl.setAttribute('data-add-note', true);
  //     }

  //     else {
  //       Product.orderDetailsEl.setAttribute('data-add-note', false);
  //       Product.addNoteInput.value = '';
  //     }
  //   }
  // }

  const ProductCustomEngrave = {
    input: document.querySelector(".js-custom-engrave-input"),
    checkbox: document.querySelector(".js-custom-engrave-checkbox"),
    orderDetailsEl: document.querySelector(".js-product-details"),

    init() {
      ProductCustomEngrave.bindEvents();
    },

    bindEvents() {
      ProductCustomEngrave.checkbox.addEventListener(
        "change",
        ProductCustomEngrave.toggleCustomEngrave
      );
    },

    toggleCustomEngrave() {
      if (ProductCustomEngrave.checkbox.checked) {
        ProductCustomEngrave.orderDetailsEl.setAttribute(
          "data-custom-engrave",
          true
        );
      } else {
        ProductCustomEngrave.orderDetailsEl.setAttribute(
          "data-custom-engrave",
          false
        );
        ProductCustomEngrave.input.value = "";
      }
    },
  };

  const ProductAddNote = {
    input: document.querySelector(".js-add-note-input"),
    checkbox: document.querySelector(".js-add-note-checkbox"),
    orderDetailsEl: document.querySelector(".js-product-details"),

    init() {
      ProductAddNote.bindEvents();
    },

    bindEvents() {
      ProductAddNote.checkbox.addEventListener(
        "change",
        ProductAddNote.toggleAddNote
      );
    },

    toggleAddNote() {
      if (ProductAddNote.checkbox.checked) {
        ProductAddNote.orderDetailsEl.setAttribute("data-add-note", true);
      } else {
        ProductAddNote.orderDetailsEl.setAttribute("data-add-note", false);
        ProductAddNote.input.value = "";
      }
    },
  };

  if (ProductAddNote.checkbox) {
    ProductAddNote.init();
  }

  if (ProductCustomEngrave.checkbox) {
    ProductCustomEngrave.init();
  }

  // on clicking on anchor href tag, smooth scroll to the section
  // adjust the offset to account for the fixed header

  const Scroll = {
    init() {
      this.bindEvents();
    },

    bindEvents() {
      const anchors = document.querySelectorAll(".js-smooth-scroll-link");
      // console.log('Scroll', anchors);

      anchors.forEach((anchor) => {
        anchor.addEventListener("click", this.smoothScroll);
      });
    },

    smoothScroll(e) {
      // smooth scroll
      // console.log('smoothScroll', e.target);

      e.preventDefault();

      let targetHref = e.target.getAttribute("href");
      let target = targetHref.substr(targetHref.indexOf("#"));
      // console.log('target', target);

      // get the anchor from the link – it will the '#' then the following id

      const offset = document.querySelector(".js-site-header").offsetHeight;
      const targetPosition = document.querySelector(target).offsetTop - offset;
      window.scroll({
        top: targetPosition,
        behavior: "smooth",
      });
    },
  };

  // on page load, if there is a hash in the url, scroll to that section (adjusting for the fixed header)
  if (window.location.hash) {
    const offset = document.querySelector(".js-site-header").offsetHeight;
    const targetPosition =
      document.querySelector(window.location.hash).offsetTop - offset;
    window.scrollTo(0, targetPosition);
  }

  let scrollTemplate = document
    .querySelector("body")
    .getAttribute("data-template");

  if (scrollTemplate === "list-collections") {
    Scroll.init();
  }
  const Spaces = {
    els: null,
    filterButtons: document.querySelectorAll(".js-space-filter-button"),
    figures: document.querySelectorAll(".js-spaces-figure-block-outer"),
    images: document.querySelectorAll(
      ".js-spaces-figure-block-outer .js-spaces-image"
    ),
    // gridContainer: document.querySelector('.js-spaces-figure-grid'),
    gridContainers: document.querySelectorAll(".js-spaces-figure-grid"),
    currentFilter: "all",

    init: function () {
      Spaces.bindEls();
      Spaces.bindEvents();

      console.log("Spaces initialized", Spaces);
    },

    bindEls: function () {
      Spaces.els = document.querySelectorAll(".js-spaces-figure-block-outer");
    },

    bindEvents: function () {
      Spaces.images.forEach((el) => {
        el.addEventListener("click", Spaces.toggleOpen);
      });

      Spaces.filterButtons.forEach((button) => {
        button.addEventListener("click", Spaces.filterSpaces);
      });
    },

    filterSpaces: function (e) {
      let filter = e.currentTarget.getAttribute("data-filter");

      Spaces.currentFilter = filter;

      // remove 'is-active' class from all filter buttons
      Spaces.filterButtons.forEach((button) => {
        button.classList.remove("is-active");
      });

      // add 'is-active' class to the clicked filter button
      e.currentTarget.classList.add("is-active");

      // Spaces.gridContainer.setAttribute('data-filter-by', filter);
      Spaces.gridContainers.forEach((grid) => {
        grid.setAttribute("data-filter-by", filter);
      });

      // set a 'is-showing' class on all figures that match the filter
      Spaces.figures.forEach((figure) => {
        // if the figures data-filter contains the filter, add 'is-showing' class
        if (figure.getAttribute("data-tags").includes(filter)) {
          figure.classList.add("is-showing");
        } else {
          figure.classList.remove("is-showing");
        }
      });

      // remove 'is-last-showing' class from all figures
      Spaces.figures.forEach((figure) => {
        figure.classList.remove("is-last-showing");
      });

      // get the last figure that is showing not with a :last-child selector
      let lastShowing = null;
      Spaces.figures.forEach((figure) => {
        if (figure.classList.contains("is-showing")) {
          lastShowing = figure;
        }
      });

      // add 'is-last-showing' class to the last figure that is showing
      lastShowing.classList.add("is-last-showing");
    },

    toggleOpen: function (e) {
      let clickedImage = e.currentTarget;

      // closest 'js-spaces-figure-block-outer' is the clicked figure
      let clickedFigure = e.currentTarget.closest(
        ".js-spaces-figure-block-outer"
      );

      console.log(clickedFigure, "clickedFigure", clickedImage, "clickedImage");

      // if the clicked figure is not open, open it

      // close all other open spaces
      Spaces.figures.forEach((el) => {
        if (el !== clickedFigure) {
          el.classList.remove("is-open");
          el.classList.remove("next-space-is-open");
        }
      });

      // toggle the clicked space
      clickedFigure.classList.toggle("is-open");

      // get the direct previous sibling of the clicked space
      let prevSibling = clickedFigure.previousElementSibling;

      if (prevSibling !== null) {
        // add a class to the previous sibling
        prevSibling.classList.toggle("next-space-is-open");
      }
    },
  };

  let spacesTemplate = document
    .querySelector("body")
    .getAttribute("data-template");
  if (spacesTemplate === "page-spaces") {
    Spaces.init();
  }
  let bigSpillObjectZIndex = 1000;

  // make a class for the moveable objects
  class BigSpillObject {
    constructor(id, x, y, rotation, productReference) {
      this.id = id;
      this.x = x;
      this.y = y;
      this.rotation = rotation;
      this.productReference = productReference;
      this.element = null;
      this.rightPercent = null;
      this.bottomPercent = null;
      this.widthPercent = null;
      this.heightPercent = null;
      this.zIndex = id;
      this.dragging = false;

      this.clickStopwatch = 0;
      this.clickX = null;
      this.clickY = null;

      this.startDragX = null;
      this.startDragY = null;

      this.makeElement();
      this.logObject();
      if (this.element !== null) {
        this.bindEvents();
      }
    }

    bindEvents() {
      let self = this;
      self.element.addEventListener("click", (e) => {
        // self.rotate();
      });

      self.element.addEventListener("mousedown", (e) => {
        // console.log('mousedown', this.productReference);
        self.startDrag(e);
      });

      document.addEventListener("mousemove", (e) => {
        // console.log('mousemove', this.productReference);
        self.drag(e);
      });

      self.element.addEventListener("mouseup", (e) => {
        console.log("mouseup", this.productReference);
        self.endDrag(e);
      });

      // // order the objects in BigSpill.classObjectsArray by productReference
      // BigSpill.classObjectsArray.sort((a, b) => {
      //   return a.productReference.localeCompare(b.productReference);
      // });
    }

    startDrag(e) {
      // z index
      bigSpillObjectZIndex = bigSpillObjectZIndex + 10;
      this.element.style.zIndex = bigSpillObjectZIndex;

      // set dragging to true
      this.dragging = true;
      this.startDragX = e.clientX;
      this.startDragY = e.clientY;
      this.element.classList.add("is-dragging");

      // start the stopwatch
      this.clickStopwatch = new Date().getTime();
      this.clickX = e.clientX;
      this.clickY = e.clientY;
    }

    drag(e) {
      if (this.dragging) {
        let xDiff = (e.clientX - this.startDragX) * -1;
        let yDiff = (e.clientY - this.startDragY) * -1;
        this.startDragX = e.clientX;
        this.startDragY = e.clientY;

        // get actual width of the wall area
        let wallAreaWidth = BigSpill.wallArea.offsetWidth;
        let wallAreaHeight = BigSpill.wallArea.offsetHeight;

        // get the percentage of the width and height
        let xPercent = (xDiff / wallAreaWidth) * 100;
        let yPercent = (yDiff / wallAreaHeight) * 100;

        // get the current right and bottom percentages
        let currentRightPercent = this.rightPercent;
        let currentBottomPercent = this.bottomPercent;

        // add the x and y percentages to the current right and bottom percentages
        let newRightPercent = currentRightPercent + xPercent;
        let newBottomPercent = currentBottomPercent + yPercent;

        // set the new right and bottom percentages
        this.element.style.right = newRightPercent + "%";
        this.element.style.bottom = newBottomPercent + "%";

        // set the new right and bottom percentages to the object
        this.rightPercent = newRightPercent;
        this.bottomPercent = newBottomPercent;

        // re-calculate the x and y based on the new right and bottom percentages
        let newX = (newRightPercent / 100) * BigSpill.canvasSize.width;
        let newY = (newBottomPercent / 100) * BigSpill.canvasSize.height;

        // set the new x and y to the object
        this.x = parseInt(newX);
        this.y = parseInt(newY);

        // update the JSON
        BigSpill.createProductJSON();
      }
    }

    endDrag(e) {
      self = this;
      this.dragging = false;
      this.element.classList.remove("is-dragging");

      // stop the stopwatch
      let clickDuration = new Date().getTime() - this.clickStopwatch;

      // get mouseX and mouseY
      let mouseX = e.clientX;
      let mouseY = e.clientY;

      if (this.clickX === mouseX && this.clickY === mouseY) {
        this.rotate();
      }

      // // get bin element
      let binEl = BigSpill.binEl;
      // get computed position of bin element
      let binElComputed = binEl.getBoundingClientRect();

      console.log("binElComputed", binElComputed);

      // get the bounds of the bin element
      let binXLeftBound = binElComputed.left;
      let binXRightBound = binElComputed.right;
      let binYTopBound = binElComputed.top;
      let binYBottomBound = binElComputed.bottom;

      // log all the bounds
      console.log("binXLeftBound", binXLeftBound);
      console.log("binXRightBound", binXRightBound);
      console.log("binYTopBound", binYTopBound);
      console.log("binYBottomBound", binYBottomBound);

      // log if the mouse x is within the bounds
      if (mouseX > binXLeftBound && mouseX < binXRightBound) {
        console.log("mouse x is within bounds");
      } else {
        console.log("mouse x is not within bounds");
      }

      // log if the mouse y is within the bounds
      if (mouseY > binYTopBound && mouseY < binYBottomBound) {
        console.log("mouse y is within bounds");
      } else {
        console.log("mouse y is not within bounds");
      }

      if (
        mouseX > binXLeftBound &&
        mouseX < binXRightBound &&
        mouseY > binYTopBound &&
        mouseY < binYBottomBound
      ) {
        console.log("delete");
        this.destoryInstance();
      }

      // nullify startDragX and startDragY
      this.startDragX = null;
      this.startDragY = null;
    }

    makeElement() {
      // check if the product reference exists
      if (!bigSpillProducts[this.productReference]) {
        console.log("Product reference does not exist", this.productReference);
        return;
      }

      this.element = document.createElement("figure");
      this.element.classList.add("big-spill-moveable-object");
      this.element.classList.add("js-big-spill-moveable-object");
      this.element.setAttribute("data-reference", this.productReference);
      let productElImg = document.createElement("img");
      let productElImgSrcReference = this.productReference;

      productElImg.src = bigSpillProducts[productElImgSrcReference].image;
      this.element.appendChild(productElImg);
      BigSpill.wallArea.appendChild(this.element);

      // set rotation
      this.element.style.transform =
        "translate(50%, 50%) rotate(" + this.rotation + "deg)";
      this.element.setAttribute("data-rotation", this.rotation);
      this.element.setAttribute("data-x", this.x);
      this.element.setAttribute("data-y", this.y);

      // set z-index
      bigSpillObjectZIndex = bigSpillObjectZIndex + 10;
      this.element.style.zIndex = bigSpillObjectZIndex;

      let xmm = this.x;
      let ymm = this.y;

      let xpercent = (xmm / BigSpill.canvasSize.width) * 100;
      let ypercent = (ymm / BigSpill.canvasSize.height) * 100;

      let productWidthMM = bigSpillProducts[this.productReference].imageWidthMM;
      let productHeightMM =
        bigSpillProducts[this.productReference].imageHeightMM;

      let productWidthPercent =
        (productWidthMM / BigSpill.canvasSize.width) * 100;
      let productHeightPercent =
        (productHeightMM / BigSpill.canvasSize.height) * 100;

      this.element.style.position = "absolute";

      this.element.style.right = xpercent + "%";
      this.element.style.bottom = ypercent + "%";

      this.element.style.width = productWidthPercent + "%";
      this.element.style.height = productHeightPercent + "%";

      this.rightPercent = xpercent;
      this.bottomPercent = ypercent;
      this.widthPercent = productWidthPercent;
      this.heightPercent = productHeightPercent;
    }

    rotate() {
      this.rotation += BigSpill.rotateIteration;
      this.element.style.transform =
        "translate(50%, 50%) rotate(" + this.rotation + "deg)";
    }

    logObject() {
      // console.log('BigSpillObject', this);
    }

    destoryInstance() {
      console.log("*** Destroy instance");

      // remove the object the BigSpill.classObjectsArray list
      for (let i = 0; i < BigSpill.classObjectsArray.length; i++) {
        if (BigSpill.classObjectsArray[i].id == this.id) {
          BigSpill.classObjectsArray.splice(i, 1);
        }
      }

      // remove the element from the DOM
      this.element.remove();

      // update the list of products
      BigSpill.listProducts();
    }
  }

  const BigSpill = {
    screenshotArea: document.querySelector(".js-big-spill-screenshot-area"),
    wallArea: document.querySelector(".js-big-spill-wall-area"),
    screenshotTrigger: document.querySelector(
      ".js-big-spill-screenshot-trigger"
    ),
    rotateIteration: 22.5,
    testAddProductTrigger: document.querySelector(".js-big-spill-add-product"),
    addProductTriggers: document.querySelectorAll(".js-big-spill-add-product"),
    // todo multiple add product trigger
    addProductPositionX: 2400,
    addProductPositionY: 1200,
    clearAllTriggers: document.querySelectorAll(".js-big-spill-clear-all"),
    binEl: document.querySelector(".js-big-spill-bin"),
    classObjectsArray: [],
    canvasSize: {
      width: 4800,
      height: 2400,
    },
    numberOfProducts: 0,
    meetsCheckoutRequirements: false, // must be at least 12 products
    checkoutButton: document.querySelector(".js-bs-checkout-link"),
    infoArea: {
      open: true,
      element: document.querySelector(".js-big-spill-info-area"),
      trigger: document.querySelector(".js-big-spill-info-trigger"),
      closeTrigger: document.querySelector(".js-big-spill-info-close-trigger"),
    },
    installation: {
      custom: false,
      productVariantID: 44897487028373,
      checkbox: document.querySelector(".js-big-spill-installation-checkbox"),
    },
    currentPresetNum: 0,
    changePresetTrigger: document.querySelector(".js-big-spill-change-preset"),
    decreaseButtons: document.querySelectorAll(".js-bs-product-qty-decrease"),
    increaseButtons: document.querySelectorAll(".js-bs-product-qty-increase"),
    presets: {
      layout1: {
        title: "Small",
        products: [
          {
            reference: "product_43630052409493",
            x: 1228,
            y: 1649,
            rotate: 607.5,
          },
          {
            reference: "product_44782978367637",
            x: 1737,
            y: 1713,
            rotate: 22.5,
          },
          {
            reference: "product_43630034124949",
            x: 1312,
            y: 1268,
            rotate: 202.5,
          },
          { reference: "product_43630052212885", x: 1862, y: 982, rotate: 90 },
          {
            reference: "product_43630034092181",
            x: 2062,
            y: 1392,
            rotate: 315,
          },
          {
            reference: "product_36512761381013",
            x: 2207,
            y: 878,
            rotate: 337.5,
          },
          {
            reference: "product_43771387084949",
            x: 2448,
            y: 1240,
            rotate: 202.5,
          },
          { reference: "product_43630052278421", x: 2528, y: 866, rotate: 0 },
          { reference: "product_43630052081813", x: 2617, y: 1524, rotate: 90 },
          {
            reference: "product_36512761381013",
            x: 3078,
            y: 1175,
            rotate: 382.5,
          },
          {
            reference: "product_43630033895573",
            x: 3058,
            y: 718,
            rotate: 382.5,
          },
          { reference: "product_44897477918869", x: 807, y: 1948, rotate: 0 },
        ],
      },
      layout2: {
        title: "Medium",
        products: [
          {
            reference: "product_43630052409493",
            x: 2593,
            y: 1104,
            rotate: 810,
          },
          {
            reference: "product_44782978367637",
            x: 1482,
            y: 1667,
            rotate: 337.5,
          },
          {
            reference: "product_43630034124949",
            x: 2510,
            y: 648,
            rotate: 337.5,
          },
          {
            reference: "product_36512761381013",
            x: 1637,
            y: 2014,
            rotate: 652.5,
          },
          {
            reference: "product_43771387084949",
            x: 1832,
            y: 896,
            rotate: 202.5,
          },
          { reference: "product_43630052278421", x: 2876, y: 1537, rotate: 0 },
          { reference: "product_43630052376725", x: 1122, y: 1744, rotate: 0 },
          {
            reference: "product_36512761381013",
            x: 3179,
            y: 1007,
            rotate: 315,
          },
          {
            reference: "product_43630037663893",
            x: 3824,
            y: 856,
            rotate: 652.5,
          },
          {
            reference: "product_43630034092181",
            x: 1956,
            y: 1602,
            rotate: 337.5,
          },
          { reference: "product_43630052245653", x: 3024, y: 605, rotate: 180 },
          {
            reference: "product_43630047953045",
            x: 4104,
            y: 1267,
            rotate: 22.5,
          },
          { reference: "product_43630052475029", x: 4519, y: 751, rotate: 0 },
          { reference: "product_44897477918869", x: 656, y: 2011, rotate: 0 },
        ],
      },
      layout3: {
        title: "Large",
        products: [
          {
            reference: "product_43630052409493",
            x: 3091,
            y: 1272,
            rotate: 810,
          },
          {
            reference: "product_44782978367637",
            x: 1482,
            y: 1667,
            rotate: 337.5,
          },
          {
            reference: "product_43630034124949",
            x: 2313,
            y: 832,
            rotate: 652.5,
          },
          {
            reference: "product_36512761381013",
            x: 1637,
            y: 2014,
            rotate: 652.5,
          },
          {
            reference: "product_43771387084949",
            x: 1803,
            y: 1009,
            rotate: 202.5,
          },
          { reference: "product_43630052278421", x: 2876, y: 1537, rotate: 0 },
          { reference: "product_43630052376725", x: 1122, y: 1744, rotate: 0 },
          { reference: "product_36512761381013", x: 2588, y: 613, rotate: 315 },
          {
            reference: "product_43630037663893",
            x: 3987,
            y: 1086,
            rotate: 652.5,
          },
          {
            reference: "product_43630034092181",
            x: 1956,
            y: 1602,
            rotate: 337.5,
          },
          {
            reference: "product_43630052245653",
            x: 3354,
            y: 1024,
            rotate: 180,
          },
          {
            reference: "product_43630047953045",
            x: 3932,
            y: 1367,
            rotate: 22.5,
          },
          { reference: "product_43630052475029", x: 4201, y: 739, rotate: 0 },
          { reference: "product_43630052114581", x: 2391, y: 1417, rotate: 0 },
          { reference: "product_43630052343957", x: 2387, y: 1710, rotate: 45 },
          {
            reference: "product_43630048018581",
            x: 1445,
            y: 982,
            rotate: 337.5,
          },
          { reference: "product_43630037631125", x: 3091, y: 772, rotate: 45 },
          {
            reference: "product_36512761381013",
            x: 3664,
            y: 517,
            rotate: 22.5,
          },
          {
            reference: "product_43771387084949",
            x: 3401,
            y: 1493,
            rotate: 202.5,
          },
          { reference: "product_43630034092181", x: 4330, y: 299, rotate: 135 },
          {
            reference: "product_43630052212885",
            x: 2638,
            y: 1124,
            rotate: 67.5,
          },
          { reference: "product_44897477918869", x: 656, y: 2011, rotate: 0 },
        ],
      },
    },

    init: function () {
      BigSpill.cleanProductPresets();
      BigSpill.placeProducts("layout1");
      BigSpill.bindEvents();
    },

    cleanProductPresets: function () {
      console.log("Cleaning product presets");

      // clean BigSpill.presets.layout1
      let layout1Products = BigSpill.presets.layout1.products;
      // cross reference the products with the bigSpillProducts object
      // if the product does not exist in the bigSpillProducts object, then remove it from the layout1Products array

      for (let i = 0; i < layout1Products.length; i++) {
        console.log("layout1Products[i]", layout1Products[i]);
        let product = layout1Products[i];
        if (!bigSpillProducts[product.reference]) {
          layout1Products.splice(i, 1);
          console.log("product does not exist - removed", product.reference);
        }
      }

      // clean BigSpill.presets.layout2
      let layout2Products = BigSpill.presets.layout2.products;

      for (let i = 0; i < layout2Products.length; i++) {
        console.log("layout2Products[i]", layout2Products[i]);
        let product = layout2Products[i];
        if (!bigSpillProducts[product.reference]) {
          layout2Products.splice(i, 1);
          console.log("product does not exist - removed", product.reference);
        }
      }

      // clean BigSpill.presets.layout3
      let layout3Products = BigSpill.presets.layout3.products;

      for (let i = 0; i < layout3Products.length; i++) {
        console.log("layout3Products[i]", layout3Products[i]);
        let product = layout3Products[i];
        if (!bigSpillProducts[product.reference]) {
          layout3Products.splice(i, 1);
          console.log("product does not exist - removed", product.reference);
        }
      }
    },
    bindEvents: function () {
      BigSpill.screenshotTrigger.addEventListener("click", BigSpill.screenshot);
      BigSpill.testAddProductTrigger.addEventListener(
        "click",
        BigSpill.addProduct
      );

      for (let i = 0; i < BigSpill.addProductTriggers.length; i++) {
        BigSpill.addProductTriggers[i].addEventListener(
          "click",
          BigSpill.addProduct
        );
      }

      for (let i = 0; i < BigSpill.clearAllTriggers.length; i++) {
        BigSpill.clearAllTriggers[i].addEventListener(
          "click",
          BigSpill.clearAll
        );
      }

      BigSpill.infoArea.trigger.addEventListener(
        "click",
        BigSpill.toggleInfoArea
      );
      BigSpill.infoArea.closeTrigger.addEventListener(
        "click",
        BigSpill.toggleInfoArea
      );
      BigSpill.installation.checkbox.addEventListener(
        "change",
        BigSpill.toggleInstallation
      );
      BigSpill.changePresetTrigger.addEventListener(
        "click",
        BigSpill.changePreset
      );

      // add mouseover and mouseout events to the bin
      BigSpill.binEl.addEventListener("mouseover", (e) => {
        BigSpill.binEl.classList.add("is-open");
      });

      BigSpill.binEl.addEventListener("mouseout", (e) => {
        BigSpill.binEl.classList.remove("is-open");
      });
    },

    toggleInfoArea: function () {
      if (BigSpill.infoArea.open) {
        BigSpill.infoArea.element.classList.add("is-closed");
        BigSpill.infoArea.open = false;
      } else {
        BigSpill.infoArea.element.classList.remove("is-closed");
        BigSpill.infoArea.open = true;
      }
    },

    toggleInstallation: function () {
      // check if the installation checkbox is checked
      if (BigSpill.installation.checkbox.checked) {
        BigSpill.installation.custom = true;
      } else {
        BigSpill.installation.custom = false;
      }

      BigSpill.listProducts();
    },

    changePreset: function () {
      // change the preset
      BigSpill.currentPresetNum++;
      if (BigSpill.currentPresetNum > 2) {
        BigSpill.currentPresetNum = 0;
      }

      let preset = "layout" + (BigSpill.currentPresetNum + 1);

      BigSpill.clearAll();
      BigSpill.placeProducts(preset);
    },

    placeProducts: function (preset) {
      // take products from preset and place them on the canvas
      const products = BigSpill.presets[preset].products;
      for (let i = 0; i < products.length; i++) {
        let product = products[i];

        let bigSpillObject = new BigSpillObject(
          i,
          product.x,
          product.y,
          product.rotate,
          product.reference
        );

        BigSpill.classObjectsArray.push(bigSpillObject);
        BigSpill.numberOfProducts++;
      }

      BigSpill.listProducts();
    },

    addProduct: function (e) {
      let clickedEl = e.target;
      let addProductButton = clickedEl.closest(".js-big-spill-add-product");
      let productReference = addProductButton.getAttribute(
        "data-product-reference"
      );

      // console.log('add product', productReference, clickedEl);

      // add a product to the canvas
      // console.log('add product');
      let bigSpillObject = new BigSpillObject(
        BigSpill.numberOfProducts,
        BigSpill.addProductPositionX,
        BigSpill.addProductPositionY,
        0,
        productReference
      );

      BigSpill.classObjectsArray.push(bigSpillObject);
      BigSpill.numberOfProducts++;
      BigSpill.listProducts();
    },

    listProducts: function () {
      // if the number of products is less than 0,
      // display 'Add pieces to get started' then return
      if (BigSpill.numberOfProducts < 1) {
        document.querySelector(".js-big-spill-product-list").innerHTML =
          '<li class="big-spill-product-list-item secondary">Add pieces to get started</li>';
        return;
      }

      // clear the product list
      document.querySelector(".js-big-spill-product-list").innerHTML = "";
      let productsCheckoutArray = [];

      // loop through all BigSpillObject instances and get the title and price
      // console.log('list products');
      for (let i = 0; i < BigSpill.classObjectsArray.length; i++) {
        let product = BigSpill.classObjectsArray[i];
        let productReference = product.productReference;
        let productTitle = bigSpillProducts[productReference].titleVariant;

        // if product title contains 'Default Title' then use the product title
        if (productTitle.includes("Default Title")) {
          productTitle = bigSpillProducts[productReference].title;
        }
        let productPrice = bigSpillProducts[productReference].price;
        let productPriceFormatted = "$" + productPrice + ".00";
        // console.log('product', productTitle, productPriceFormatted);

        let productVariantID = bigSpillProducts[productReference].variantID;

        // console.log('productVariantID', productVariantID);

        // create an object for the products checkout array
        let productCheckoutObject = {
          title: productTitle,
          productReference: productReference,
          price: productPrice,
          priceFormatted: productPriceFormatted,
          variantID: productVariantID,
          quantity: 1,
        };

        // check if the product is already in the products checkout array
        let productAlreadyInArray = false;

        for (let j = 0; j < productsCheckoutArray.length; j++) {
          if (productsCheckoutArray[j].productReference == productReference) {
            productAlreadyInArray = true;
          }
        }

        // if the product is not in the products checkout array, then add it
        if (!productAlreadyInArray) {
          productsCheckoutArray.push(productCheckoutObject);
        }
        // if the product is in the products checkout array, then update the quantity
        else {
          for (let j = 0; j < productsCheckoutArray.length; j++) {
            if (productsCheckoutArray[j].productReference == productReference) {
              productsCheckoutArray[j].quantity++;
            }
          }
        }
      }

      // create a product list item from the product checkout array
      for (let i = 0; i < productsCheckoutArray.length; i++) {
        let product = productsCheckoutArray[i];
        let productEl = document.createElement("li");
        // add class 'big-spill-product-list-item'
        productEl.classList.add("big-spill-product-list-item");

        // make productElQty decrease and increase buttons
        let productElQtyDecrease = document.createElement("button");
        productElQtyDecrease.classList.add("bs-product-qty-decrease");
        productElQtyDecrease.classList.add("bs-product-qty-button");
        // add a js class
        productElQtyDecrease.classList.add("js-bs-product-qty-decrease");
        // add a reference to the product
        productElQtyDecrease.setAttribute(
          "data-product-reference",
          product.productReference
        );
        productElQtyDecrease.innerHTML = "–";

        let productElQtyIncrease = document.createElement("button");
        productElQtyIncrease.classList.add("bs-product-qty-increase");
        productElQtyIncrease.classList.add("bs-product-qty-button");
        // add a js class
        productElQtyIncrease.classList.add("js-bs-product-qty-increase");
        // add a reference to the product
        productElQtyIncrease.setAttribute(
          "data-product-reference",
          product.productReference
        );
        productElQtyIncrease.innerHTML = "+";

        let productCurrentQty = document.createElement("span");
        productCurrentQty.classList.add("bs-product-qty-current");
        productCurrentQty.innerHTML = product.quantity;

        let productElQty = document.createElement("div");
        productElQty.classList.add("bs-product-qty");
        productElQty.appendChild(productElQtyDecrease);
        productElQty.appendChild(productCurrentQty);
        productElQty.appendChild(productElQtyIncrease);

        productEl.appendChild(productElQty);

        let productElTitle = document.createElement("div");
        productElTitle.classList.add("bs-product-title");
        productElTitle.innerHTML = product.title;
        productEl.appendChild(productElTitle);

        let productElPrice = document.createElement("div");
        productElPrice.classList.add("bs-product-price");
        productElPrice.innerHTML = product.priceFormatted;
        productEl.appendChild(productElPrice);

        document
          .querySelector(".js-big-spill-product-list")
          .appendChild(productEl);
      }

      let installationProductPrice = 0;

      // check if custom installation is checked
      if (BigSpill.installation.custom) {
        installationProductPrice = 500;

        let installationProductEl = document.createElement("li");
        installationProductEl.classList.add("big-spill-product-list-item");
        installationProductEl.classList.add("bs-installation");

        // create decrease and increase buttons, and current qty
        let installationProductElQty = document.createElement("div");
        installationProductElQty.classList.add("bs-product-qty");

        installationProductElQty.innerHTML = "";
        installationProductElQty.innerHTML +=
          '<button class="bs-product-qty-decrease bs-product-qty-button inactive">–</button>';
        installationProductElQty.innerHTML +=
          '<span class="bs-product-qty-current">1</span>';
        installationProductElQty.innerHTML +=
          '<button class="bs-product-qty-increase bs-product-qty-button inactive">+</button>';

        let installationProductLabel = document.createElement("div");
        installationProductLabel.classList.add("bs-product-title");
        installationProductLabel.innerHTML = "Installation";

        let installationProductValue = document.createElement("div");
        installationProductValue.classList.add("bs-product-price");
        installationProductValue.innerHTML =
          "$" + installationProductPrice + ".00";

        installationProductEl.appendChild(installationProductElQty);
        installationProductEl.appendChild(installationProductLabel);
        installationProductEl.appendChild(installationProductValue);

        // console.log('installationProductEl', installationProductEl);
        // console.log('.js-big-spill-product-list', document.querySelector('.js-big-spill-product-list'));
        document
          .querySelector(".js-big-spill-product-list")
          .appendChild(installationProductEl);
      }

      // create a total price
      let totalPrice = 0;
      for (let i = 0; i < productsCheckoutArray.length; i++) {
        let product = productsCheckoutArray[i];
        totalPrice += product.price * product.quantity;
      }

      // add installation price to total price
      totalPrice += installationProductPrice;

      let totalPriceEl = document.createElement("li");
      totalPriceEl.classList.add("big-spill-product-list-item");
      totalPriceEl.classList.add("bs-subtotal");

      let totalPriceLabel = document.createElement("div");
      totalPriceLabel.classList.add("bs-subtotal-label");
      totalPriceLabel.innerHTML = "Subtotal";

      let totalPriceValue = document.createElement("div");
      totalPriceValue.classList.add("bs-subtotal-value");
      totalPriceValue.innerHTML = "$" + totalPrice + ".00";

      totalPriceEl.appendChild(totalPriceLabel);
      totalPriceEl.appendChild(totalPriceValue);

      document
        .querySelector(".js-big-spill-product-list")
        .appendChild(totalPriceEl);

      // productsCheckoutArray
      // console.log('productsCheckoutArray', productsCheckoutArray);

      // create a link for the checkout button using qty and variantID
      let buttonLink = "/cart/";
      for (let i = 0; i < productsCheckoutArray.length; i++) {
        let product = productsCheckoutArray[i];
        buttonLink += product.variantID + ":" + product.quantity;
        if (i < productsCheckoutArray.length - 1) {
          buttonLink += ",";
        }
      }

      // if installation is custom, then add the custom installation product
      if (BigSpill.installation.custom) {
        buttonLink += "," + BigSpill.installation.productVariantID + ":1";
      }

      BigSpill.checkoutButton.href = buttonLink;

      BigSpill.bindIncreaseDecreaseButtons();
      BigSpill.createProductJSON();
      BigSpill.showButtonIncidators();
      BigSpill.reviewCheckoutRequirements();
    },

    reviewCheckoutRequirements: function () {
      // recount the number of products
      BigSpill.numberOfProducts = BigSpill.classObjectsArray.length;

      // check if the number of products is at least 6
      if (BigSpill.numberOfProducts >= 6) {
        BigSpill.meetsCheckoutRequirements = true;
      } else {
        BigSpill.meetsCheckoutRequirements = false;
      }

      if (BigSpill.meetsCheckoutRequirements) {
        BigSpill.checkoutButton.classList.remove("does-not-meet-min");
      } else {
        BigSpill.checkoutButton.classList.add("does-not-meet-min");
      }
    },

    showButtonIncidators: function () {
      // remove all is-in-canvas classes
      for (let i = 0; i < BigSpill.addProductTriggers.length; i++) {
        BigSpill.addProductTriggers[i].classList.remove("is-in-canvas");
      }

      // loop through the add product triggers and check if the product is already in the canvas
      for (let i = 0; i < BigSpill.addProductTriggers.length; i++) {
        let addProductTrigger = BigSpill.addProductTriggers[i];
        let productReference = addProductTrigger.getAttribute(
          "data-product-reference"
        );
        let productAlreadyInCanvas = false;
        let productInCanvasCount = 0;

        for (let j = 0; j < BigSpill.classObjectsArray.length; j++) {
          if (
            BigSpill.classObjectsArray[j].productReference == productReference
          ) {
            productAlreadyInCanvas = true;
            productInCanvasCount++;
          }
        }

        addProductTrigger.setAttribute(
          "data-product-in-canvas-count",
          productInCanvasCount
        );

        if (productAlreadyInCanvas) {
          addProductTrigger.classList.add("is-in-canvas");
        } else {
          addProductTrigger.classList.remove("is-in-canvas");
        }
      }
    },

    bindIncreaseDecreaseButtons: function () {
      BigSpill.decreaseButtons = document.querySelectorAll(
        ".js-bs-product-qty-decrease"
      );
      BigSpill.increaseButtons = document.querySelectorAll(
        ".js-bs-product-qty-increase"
      );
      // bind the increase and decrease buttons
      for (let i = 0; i < BigSpill.decreaseButtons.length; i++) {
        BigSpill.decreaseButtons[i].addEventListener(
          "click",
          BigSpill.decreaseProductQty
        );
      }

      for (let i = 0; i < BigSpill.increaseButtons.length; i++) {
        BigSpill.increaseButtons[i].addEventListener(
          "click",
          BigSpill.increaseProductQty
        );
      }
    },

    decreaseProductQty: function (e) {
      let clickedEl = e.target;
      let productReference = clickedEl.getAttribute("data-product-reference");
      // console.log('decrease', productReference);

      // find the product in the classObjectsArray
      for (let i = 0; i < BigSpill.classObjectsArray.length; i++) {
        if (
          BigSpill.classObjectsArray[i].productReference == productReference
        ) {
          // console.log('found product', BigSpill.classObjectsArray[i]);
          BigSpill.classObjectsArray[i].destoryInstance();
          return; // Add this line to exit the loop after finding the product
        }
      }

      BigSpill.listProducts();
    },

    increaseProductQty: function (e) {
      let clickedEl = e.target;
      let productReference = clickedEl.getAttribute("data-product-reference");
      // console.log('increase', productReference);

      // add a product to the canvas
      // console.log('add product');
      let bigSpillObject = new BigSpillObject(
        BigSpill.numberOfProducts,
        BigSpill.addProductPositionX,
        BigSpill.addProductPositionY,
        0,
        productReference
      );

      BigSpill.classObjectsArray.push(bigSpillObject);
      BigSpill.numberOfProducts++;
      BigSpill.listProducts();
    },

    createProductJSON: function () {
      // create a JSON object of the products, like the BigSpill.presets.layout1
      let productsJSON = [];
      for (let i = 0; i < BigSpill.classObjectsArray.length; i++) {
        let product = BigSpill.classObjectsArray[i];
        let productObject = {
          reference: product.productReference,
          x: product.x,
          y: product.y,
          rotate: product.rotation,
        };
        productsJSON.push(productObject);
      }

      // console.log('productsJSON', productsJSON);

      let productsJSONEl = document.querySelector(".js-bs-json");
      let productsJSONString = JSON.stringify(productsJSON);
      // add formatted JSON to the element
      // productsJSONString = productsJSONString.replace(/,/g, ',<br>');
      // productsJSONString = productsJSONString.replace(/{/g, '{<br>');
      // productsJSONString = productsJSONString.replace(/}/g, '<br>}');

      productsJSONEl.innerHTML = productsJSONString;
    },

    clearAll: function () {
      // remove all products from the canvas
      // console.log('clear all');
      let moveableObjects = document.querySelectorAll(
        ".js-big-spill-moveable-object"
      );
      for (let i = 0; i < moveableObjects.length; i++) {
        moveableObjects[i].remove();
      }

      // remove all BigSpillObject instances\
      BigSpill.numberOfProducts = 0;
      BigSpill.classObjectsArray = [];

      // clear the product list
      BigSpill.listProducts();

      // clear the button indicators
      BigSpill.showButtonIncidators();
    },

    screenshot: function () {
      // take a screenshot of the canvas
      console.log("screenshot");

      // get date in format DD-MM-YYYY
      let today = new Date();
      let dd = today.getDate();
      let mm = today.getMonth() + 1;
      let yyyy = today.getFullYear();

      if (dd < 10) {
        dd = "0" + dd;
      }

      if (mm < 10) {
        mm = "0" + mm;
      }

      today = dd + "-" + mm + "-" + yyyy;

      // get time in format HH-MM-SS
      let time = new Date();
      let hh = time.getHours();
      let min = time.getMinutes();
      let ss = time.getSeconds();

      if (hh < 10) {
        hh = "0" + hh;
      }

      if (min < 10) {
        min = "0" + min;
      }

      if (ss < 10) {
        ss = "0" + ss;
      }

      time = hh + "-" + min + "-" + ss;

      // make a filename
      let filename = "big-spill-screenshot-" + today + "-" + time + ".png";

      html2canvas(BigSpill.screenshotArea).then(function (canvas) {
        // document.body.appendChild(canvas);
        canvas.toBlob(function (blob) {
          // create a link to download the image
          let a = document.createElement("a");
          a.href = URL.createObjectURL(blob);
          a.download = filename;
          a.click();
        });
      });
    },
  };

  let bigSpillTemplateCheck = document
    .querySelector("body")
    .getAttribute("data-template");

  if (bigSpillTemplateCheck == "page-big-spill") {
    BigSpill.init();
  }

  console.log("big-spill.js");

  Site.init();
});
